// @ts-nocheck

import { createSelector } from 'reselect';

import { selectGRBetsFromRound } from '../round';

const getGRChipIndexFromProps = (_, { index }) => index ?? null;

const selectGRBet = createSelector(
  [selectGRBetsFromRound, getGRChipIndexFromProps],
  (bets, index) => bets[index] ?? null,
);

const selectGRBetBetslipReference = createSelector([selectGRBet], (bet) => bet?.betslipReference);

const selectGRBetStatus = createSelector([selectGRBet], (bet) => bet?.status);

const selectGRChipDetailsProps = createSelector(
  [selectGRBetBetslipReference, selectGRBetStatus],
  (betslipReference, status) => ({
    betslipReference,
    status,
  }),
);

export default selectGRChipDetailsProps;
